import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;
console.log(BASE_URL)
const LoginAPI = {
    async Login(data) {
        const response = await axios.post(`${BASE_URL}/login`, data);
        return {
            token: response.data.data.token,
            message: response.data.message
        }
    }
};

const RegisterAPI = {
    async Register(data) {
        return axios.post(`${BASE_URL}/register`, data);
    }
}

export {LoginAPI, RegisterAPI};